import type React from 'react';

import type { GetPermissionTagsParams } from '@vlabs/api/artemy/model/GetPermissionTagsParams';
import { FilterMenuButton } from '@vlabs/monokit/shared/ui/filter-menu';

import { usePermissionTagsFilters } from './usePermissionTagsFilters';

function getActiveFiltersCount(filters: GetPermissionTagsParams): number {
  const isDateFilterSelect = !!filters.create_time__gte || !!filters.create_time__lt;
  const isUserLoginFilterApplied = filters.created_by_user !== undefined;

  return Number(isUserLoginFilterApplied) + Number(isDateFilterSelect);
}

function PermissionTagListPageFilterMenuButton(): React.JSX.Element {
  const { filters } = usePermissionTagsFilters();

  return (
    <FilterMenuButton
      filtersCount={getActiveFiltersCount(filters)}
    />
  );
}

export { PermissionTagListPageFilterMenuButton };
